export const GET_SUGGEST_MESSAGE = "GET_SUGGEST_MESSAGE";
export const CREATE_NEW_SUGGEST_MESSAGE = "CREATE_NEW_SUGGEST_MESSAGE";
export const EDIT_SUGGEST_MESSAGE = "EDIT_SUGGEST_MESSAGE";
export const DELETE_SUGGEST_MESSAGE = "DELETE_SUGGEST_MESSAGE";

export const OPEN_SG_DIALOG = "OPEN_SG_DIALOG";
export const CLOSE_SG_DIALOG = "CLOSE_SG_DIALOG";
